import { render, staticRenderFns } from "./CargoQuote.vue?vue&type=template&id=12f60648&"
import script from "./CargoQuote.vue?vue&type=script&lang=js&"
export * from "./CargoQuote.vue?vue&type=script&lang=js&"
import style0 from "./CargoQuote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoQuote.vue"
export default component.exports